import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ReactiveService } from 'src/app/services/reactive.service';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss']
})
export class MaintenanceComponent {

  constructor(public reactiveService: ReactiveService, private configurationService: ConfigurationService, public translate: TranslateService) { }

  languageReactive: any;
  markdownContent: any;

  ngOnInit(): void {
    this.reactiveService.languageOffline$.subscribe( (react) => {
      this.languageReactive = react;
    }).unsubscribe();

    const PARSED_TEXT = JSON.parse(this.configurationService.home.maintenanceText);
    this.markdownContent = PARSED_TEXT[this.translate.currentLang.toString()];;

  }

}
